import { useMemo, useState } from "react";
import AdyenCheckout from "@adyen/adyen-web";
import "@adyen/adyen-web/dist/adyen.css";
import React, { useEffect } from "react";
import {  useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showErrorSnackbar } from "store/actions/snackbarMessage";
import API from "util/API";
import { makeStyles } from "@mui/styles";
import { logError } from "apis/utilAPIs";

import { v4 as uuid } from 'uuid';
import { Helmet } from "react-helmet";
import { Buffer } from 'buffer';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  pay: {
    margin: theme.spacing(1),
  },
}));


function getQueryParam(param) {
	const queryParams = new URLSearchParams(window.location.search);
	return queryParams.get(param); // Replace 'param' with the actual query parameter name
  }

const OBAdyenPayment = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const showError = (msg) => dispatch(showErrorSnackbar(msg));
  
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);


  // Parsed once: a new object each render would re-run the effect below and remount Drop-in
  // in the middle of a payment, losing an in-progress 3DS challenge.
  const paymentPayload = useMemo(
    () => JSON.parse(Buffer.from(getQueryParam('paymentDetails'), "base64").toString()),
    []
  );



  const handleSuccessResult = () => {
    console.log("Payment completed");
    if (paymentPayload.redirectUrl) {
      window.location.href = paymentPayload.redirectUrl;
    } else {
      const orderNumber = paymentPayload.orderNumber || paymentPayload.reference;

    // use url redirect
      window.location.href = `/obPaymentSuccess/${orderNumber}`;
    }

  };

  const handleOnAdditionalDetails = async (state, dropinComponent) => {
    // console.log('state', state);
    try {
      setIsSubmitting(true);
      const result = await API.post(`adyenPaymentDetails`, {
        payload: state.data,
      });
      if (result && result.data && result.data.action) {
        dropinComponent.handleAction(result.data.action);
      } else if (
        result &&
        result.data &&
        result.data.resultCode === "Authorised"
      ) {
        handleSuccessResult();
      } else {
        showError("The payment failed, please try again");
      }
    } catch (error) {
      logError(error);
      showError("Payment failed, please try again");
      history.goBack();
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOnSubmit = async (state, dropinComponent) => {
    try {
      if (isSubmitting) {
        return;
      }
      setIsSubmitting(true);

      if (!state.isValid) {
        setIsSubmitting(false);
        showError("Invalid payment details");
        return;
      }

      

       // Generate an idempotency key
       const idempotencyKey = uuid();
      // call API to make the payment

      let response;
      let payload;
      if (paymentPayload.isPreAuth === true) {
        payload = {
          reference: paymentPayload.reference,
          isPreAuth: true,
          paymentType: paymentPayload.paymentType,
          restaurantId: paymentPayload.restaurantId,
          total: paymentPayload.total,
          totalCent: paymentPayload.totalCent,
          merchantTotal: paymentPayload.merchantTotal,
          redirectUrl: paymentPayload.redirectUrl,
          stateData: state.data,
          merchantId: paymentPayload.merchantId,
          shopperEmail: paymentPayload.customerEmail,
          idempotencyKey,
          browserInfo: {
            userAgent: navigator.userAgent,
            javaEnabled: navigator.javaEnabled(),
            acceptHeader: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
            language: navigator.language, // Add the browser language here
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZoneOffset: new Date().getTimezoneOffset(),
          },
        };
        response = await API.post("/makeAdyenAuthorizePayment", payload);
      } else {
        payload = {
          orderNumber: paymentPayload.orderNumber,
          yearStr: paymentPayload.yearStr,
          dateStr: paymentPayload.dateStr,
          restaurantId: paymentPayload.restaurantId,
          total: paymentPayload.total,
          tableId: paymentPayload.orderNumber,
          stateData: state.data,
          obPayment: true,
          userId: paymentPayload.userId,
          merchantId: paymentPayload.merchantId,
          isPOSOrder: paymentPayload.isPOSOrder,
          shopperEmail: paymentPayload.customerEmail,
          idempotencyKey,
          browserInfo: {
            userAgent: navigator.userAgent,
            javaEnabled: navigator.javaEnabled(),
            acceptHeader: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
            language: navigator.language, // Add the browser language here
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZoneOffset: new Date().getTimezoneOffset(),
          },
        };
        response = await API.post("/adyenOBPayments", payload);
      }
      // console.log(response.data);

      if (response.data.action) {
        // Drop-in handles the action object from the /payments response
        dropinComponent.handleAction(response.data.action);
      } else {
        if (response.data.resultCode === "Authorised") {
          handleSuccessResult();
        } else {
          showError("Payment failed, please try again");
          try {
            const errorData = {
              title: `adyent online payment error code: `,
              message: `payload= ${JSON.stringify(payload)}, response=${JSON.stringify(response.data)}`,
            };
            logError(errorData);
          } catch (error) {
            console.error(error);
          }
        }
      }
    } catch (error) {
      console.error(error);
      try {
        const errorData = {
          title: `adyent online payment: `,
          message: `Error: ${JSON.stringify(error)}`,
        };
        logError(errorData);
      } catch (error) {
        console.error(error);
      }
      showError("Payment failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  const googlePayConfiguration = {
    amount: {
        value: (Number(paymentPayload.orderTotal) * 100).toFixed(0),
        currency: paymentPayload.currency
    },
    countryCode: paymentPayload.countryCode || "AU",
    //Set this to PRODUCTION when you're ready to accept live payments
    environment: paymentPayload.environment
};

  const configuration = {
    environment: paymentPayload.environment,
    paymentMethodsResponse: paymentPayload.paymentMethodResults,
    clientKey: paymentPayload.clientKey,
    locale: paymentPayload.locale || "en_AU",
    analytics: {
      enabled: false, // Set to false to not send analytics data to Adyen.
    },
    paymentMethodsConfiguration: {
      applepay: {
        amount: {
          value: (Number(paymentPayload.orderTotal) * 100).toFixed(0),
          currency: paymentPayload.currency,
        },
        countryCode: paymentPayload.countryCode || "AU",
      },
      googlepay: googlePayConfiguration,
      card: {
        showPayButton: true,
        hasHolderName: true,
        holderNameRequired: true,
        billingAddressRequired: false,
        amount: {
          value: (Number(paymentPayload.orderTotal) * 100).toFixed(0),
          currency: paymentPayload.currency
            ? paymentPayload.currency
            : "AUD",
        },
      },
    },

    showPayButton: true,
    onSubmit: handleOnSubmit,
    // onChange: handleOnChange, // Your function for handling onChange event
    onAdditionalDetails: handleOnAdditionalDetails,
    // onPaymentCompleted: (result, component) => {
    //     console.log("onPaymentCompleted");
    //     if (result.resultCode === "Authorised") {
    //         console.log("Payment completed");
    //         const orderNumber = order.adyenSession.orderNumber;
    //         emptyOrderCart({...order.adyenSession.order.order, id: orderNumber});
    //         history.push(
    //             `/orderSuccess/${id}/${tableId}/${orderNumber}/local`
    //           );

    //     } else {
    //         console.log("Payment failed");
    //         showError("Payment failed, please try again");
    //         history.goBack();
    //     }
    //   console.info(result, component);
    // },
    onError: (error, component) => {
      console.error(error.name, error.message, error.stack, component);
      prepareForPayment();
    },
  };

  const prepareForPayment = async () => {
    // Create an instance of AdyenCheckout using the configuration object.
    const checkout = await AdyenCheckout(configuration);
    // console.log("configuration", configuration);
    if (!document.getElementById("dropin-container")) {
      return;
    }

    // Create an instance of Drop-in and mount it to the container you created.
    const dropinComponent = checkout
      .create("dropin")
      .mount("#dropin-container");

    // console.log("dropinComponent", dropinComponent);
  };

  useEffect(() => {
    // console.log(order);
    if (paymentPayload) {
      const container = document.getElementById("dropin-container");
      if (container) {
        prepareForPayment();
      }
    }
  }, [paymentPayload]);

  const goBack = (e) => {
    props.history.goBack();
  };

  // get order number last 4 characters with uppercase
  const orderNumber = () => {
    return paymentPayload.orderNumber
      ? paymentPayload.orderNumber.slice(-4).toUpperCase()
      : "";
  };

  return (

    <div className={classes.root}>
      <Helmet>
        <script
          src="https://pay.google.com/gp/p/js/pay.js"
          type="text/javascript"
        />
      </Helmet>
      <div id="dropin-container" className={classes.pay}></div>
    </div>
  );
};

export default OBAdyenPayment;
